<app-badge>
  <mat-icon class="material-icons-outlined">note_add</mat-icon>
  <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.aggregation_type }}</span>
</app-badge>
